<template>
  <b-container
    v-if="contain || fluid"
    :fluid="fluid"
    class="d-flex flex-column mh-100 h-100"
  >
    <slot />
  </b-container>
  <b-row
    v-else
    no-gutters
    class="w-100 mh-100 h-100"
  >
    <b-col class="d-flex flex-column mh-100 h-100">
      <slot />
    </b-col>
  </b-row>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class RootContainer extends Vue {
  get contain () {
    return Boolean(this.$typedStore.currentRoute.meta.contain)
  }

  get fluid () {
    return Boolean(this.$typedStore.currentRoute.meta.fluid)
  }
}

</script>
